/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DismissInAppMessageRequest} from '@cash-web/protos/squareup/cash/messagingplatformcommon/ondemand/InAppMessageServiceProto.pb'
import {DismissInAppMessageResponse} from '@cash-web/protos/squareup/cash/messagingplatformcommon/ondemand/InAppMessageServiceProto.pb'


export const dismissInAppMessage = (request: DismissInAppMessageRequest, options?: CashRequestOptions) => post<DismissInAppMessageRequest, DismissInAppMessageResponse>("/2.0/cash/dismiss-in-app-message", request, {...options, rejectOnError: true })